import { Component, computed, input } from '@angular/core';
import { SelectionButtonComponent } from '@shared/components/challenges/elements/selection-button/selection-button.component';
import { UnselectionButtonComponent } from '@shared/components/challenges/elements/unselection-button/unselection-button.component';
import { WinCardComponent } from '@shared/components/challenges/elements/win-card/win-card.component';
import { IconComponent } from '@shared/components/icon/icon.component';
import { CampaignPhase } from '@shared/constants';
import { ElementDirective } from '@shared/directives';
import { FrequencyChallenge } from '@shared/factory';
import { FrequencyChallengeFirstVariantConfig } from '@shared/models';
import {
  RewardPipe,
  SafePipe,
  TransformUrlToBgPipe,
  VariableReplacementPipe,
} from '@shared/pipes';

import { FrequencyBaseClass } from '../frequency.base.class';

@Component({
  selector: 'b2c-variant1',
  styleUrl: './variant1.component.scss',
  templateUrl: './variant1.component.html',
  imports: [
    RewardPipe,
    SafePipe,
    IconComponent,
    ElementDirective,
    WinCardComponent,
    TransformUrlToBgPipe,
    VariableReplacementPipe,
    SelectionButtonComponent,
    UnselectionButtonComponent,
  ],
})
export class Variant1Component extends FrequencyBaseClass {
  /**
   * Render the card the way a shopper sees it once the challenge is selected —
   * its steps on show — while the challenge is in fact still unselected, and
   * drop the selection button. Set by the onboarding swipe deck, where the
   * deck's own pass/select buttons and the swipe gesture do the selecting.
   */
  previewSelected = input<boolean>(false);

  challenge = input.required<FrequencyChallenge>();
  config = input.required<FrequencyChallengeFirstVariantConfig>();

  withShadow = input<boolean>(true);
  isBisCampaign = input<boolean>(false);
  isEventChallenge = input<boolean>(false);
  phase = input<CampaignPhase>(CampaignPhase.CURRENT);

  protected remainingVisits = computed(
    () => this.challenge().target - this.challenge().progress
  );

  protected headerRewardPoints(): number {
    return this.challenge().rewardRatio;
  }
}
